/** @jsx jsx */
import React, { useMemo } from 'react';
import { css, jsx } from '@compiled/react';
import { Box } from '@atlaskit/primitives';

import { MenuItem } from './menu-item';
import { useMenuItems } from './util';

type Props = {
	isJsm: boolean;
	currentConfigQuery: string;
	onNavigate: (configParam: string) => void;
};

const Menu = ({ isJsm, currentConfigQuery, onNavigate }: Props) => {
	const menuItems = useMenuItems(isJsm);
	const options = useMemo(
		() =>
			menuItems.map(({ id, name, configQuery }) => (
				<MenuItem
					key={id}
					name={name}
					isSelected={currentConfigQuery === configQuery}
					onClick={() => {
						localStorage.setItem('selectedConfigTab', `"${configQuery}"`);
						onNavigate(configQuery);
					}}
				/>
			)),
		[currentConfigQuery, onNavigate, menuItems],
	);

	return (
		<Box paddingInlineEnd="space.500" paddingBlockStart="space.250" paddingBlockEnd="space.250">
			<ul css={listStyles}>{options}</ul>
		</Box>
	);
};

const listStyles = css({
	padding: 0,
});

export default Menu;
